import { Separator } from "@components/ui/separator";
import { WorkspaceChatCard } from "@components/shared/workspace/Workspace";
import WorkflowBuddy from "./workflow-panel/WorkflowBuddy";
import AdsChat from "./workflow-panel/AdsChat";

export default function WorkflowPanel() {
  return (
    <WorkspaceChatCard>
      <WorkflowBuddy />
      <Separator className="bg-neutral-300" />
      <AdsChat />
    </WorkspaceChatCard>
  );
}